import { api } from '../axiosClient';
import { DASHBOARDS_PATH } from './constants';
import {
  CreateDashboardPayload,
  Dashboard,
  DashboardUsageLimit,
} from './dashboards.types';

export const getDashboard = (id: number): Promise<Dashboard> => {
  return api.get(`${DASHBOARDS_PATH}/${id}`);
};

export const getDashboardToken = (id: number): Promise<string> => {
  return api.get(`${DASHBOARDS_PATH}/${id}/token`);
};

export const getDashboardsUsageLimit = (): Promise<DashboardUsageLimit> => {
  return api.get(`${DASHBOARDS_PATH}/usage-limits`);
};

export const postDashboard = (
  payload: CreateDashboardPayload,
): Promise<Dashboard> => {
  return api.post(DASHBOARDS_PATH, payload);
};
